import React, { createContext, useContext } from 'react'
import useWpMenuItems from 'layouts/shop/WpHeader/useWpMenuItems'

// Create the context
const WpMenuContext = createContext()

// Custom hook to use the context
export const useWpMenuContext = () => {
  const context = useContext(WpMenuContext)
  if (!context) {
    throw new Error('useWpMenuContext must be used within a WpMenuProvider')
  }
  return context
}

// Provider component
export const WpMenuProvider = ({ children }) => {
  // Call the hook here to get menu data
  const menuData = useWpMenuItems()
  
  return (
    <WpMenuContext.Provider value={menuData}>
      {children}
    </WpMenuContext.Provider>
  )
}

export default WpMenuContext